import { useMemo } from "react";
import { buildExpandedAccess } from "~/pages/manifold-nextgen/components/share/AccessDetailsView";
import {
  type AccessLevelOption,
  type ShareCollaborators,
} from "~/pages/manifold-nextgen/components/share/types";

/**
 * Whether an entity is shared with anyone beyond its owner, for the overview
 * header's shared/private indicator. `undefined` while the collaborator fetch
 * is in flight, so the caller can hold the indicator rather than guessing.
 */
export const useIsShared = (
  collaborators: ShareCollaborators | undefined,
  accessLevels: Record<string, AccessLevelOption>
): boolean | undefined =>
  useMemo(() => {
    if (!collaborators) {
      return undefined;
    }
    return buildExpandedAccess(collaborators.users, collaborators.groups, accessLevels).length > 1;
  }, [collaborators, accessLevels]);
